// extracted by mini-css-extract-plugin
module.exports = {"component":"ButtonGroup_component__2oqTw"};